export const initialState = {
  currentWeatherRequestLocation: {
    lat: null,
    lon: null,
  },
  currentLoadedWeatherDetails: {
    location: {
      lat: null,
      lon: null,
      name: null,
    },
    locationTimeZone: null,
    weatherObservationTime: null,
    currentWeatherLocationUpdatetime: {},
    weatherStations: {
      observational: {},
      closestLocations: {},
    },
    closestLocationsByDistance: {},
  },
};

// ------------------------------------
// Constants
// ------------------------------------
const WEATHER_UPDATE_LOADED_WEATHER_DETAILS =
  'WEATHER_UPDATE_LOADED_WEATHER_DETAILS';
const WEATHER_UPDATE_VIEWPORT = 'WEATHER_UPDATE_VIEWPORT';

// ------------------------------------

const createAction = (type, payload = undefined, options = {}) => ({
  type,
  payload,
  ...options,
});

// ------------------------------------
// Actions
// ------------------------------------
/* eslint-disable max-len */
export const updateLoadedWeatherDetails = (loadedWeatherDetails) =>
  createAction(WEATHER_UPDATE_LOADED_WEATHER_DETAILS, loadedWeatherDetails);
export const updateWeatherViewport = (updateWeatherViewportPayload) =>
  createAction(WEATHER_UPDATE_VIEWPORT, updateWeatherViewportPayload);
/* eslint-enable max-len */

// ------------------------------------
// Reducer
// ------------------------------------
export const reducer = (state = initialState, action) => {
  let newState = {};

  switch (action.type) {
    case WEATHER_UPDATE_VIEWPORT: {
      if (!action.payload || !action.payload.viewPortDetails)
        return { ...state };

      newState = { ...state };

      const { viewPortDetails, weatherOnMapCenter } = action.payload;

      const newRequestLocation =
        state.locationOnRouteLoad || viewPortDetails.center;

      if (newRequestLocation && !weatherOnMapCenter) {
        newState.currentWeatherRequestLocation = newRequestLocation;
      }
      if (viewPortDetails.center && weatherOnMapCenter) {
        newState.currentWeatherRequestLocation = viewPortDetails.center;
      }

      return { ...newState };
    }

    case WEATHER_UPDATE_LOADED_WEATHER_DETAILS: {
      if (!action.payload) return { ...state };

      const currentLoadedWeatherState = state.currentLoadedWeatherDetails;

      newState = { ...state };
      newState.currentLoadedWeatherDetails = {
        ...currentLoadedWeatherState,
        ...action.payload,
      };

      return { ...newState };
    }

    default:
      return state;
  }
};

// ------------------------------------
// Selectors
// ------------------------------------
export const selectCurrentLoadedWeatherLocation = (state) =>
  state?.weather?.currentLoadedWeatherDetails?.location;
